import "./Checkbox.less";

import * as React from "react";

const Checkbox = props => {
	const { id, disabled, name, checked, onClick, children } = props;

	return (
		<div className="checkbox-group">
			<label>
				<span className="checkbox">
					<input id={id} name={name} type="checkbox" checked={checked} onChange={onClick} disabled={disabled} />
					<span className="check" />
				</span>
				<span className="label">{children}</span>
			</label>
		</div>
	);
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/inputs/Checkbox/Checkbox.js